import Skeleton from "react-loading-skeleton";
import DarkAwareSkeletonTheme from "../../DarkAwareSkeletonTheme";

const NotificationCardSkeletonItem = () => (
  <div
    className="notificationCard notification-card-skeleton"
    aria-hidden="true"
    style={{ cursor: "default", pointerEvents: "none" }}
  >
    <div className="icon">
      <Skeleton width={40} height={40} borderRadius={10} />
    </div>
    <div className="detail w-100">
      <div className="d-flex justify-content-between align-items-start mb-1">
        <Skeleton height={16} width="42%" borderRadius={4} />
        <Skeleton width={12} height={12} borderRadius={2} />
      </div>
      <Skeleton height={14} width="78%" borderRadius={4} className="mb-2" />
      <Skeleton height={12} width="36%" borderRadius={4} />
    </div>
  </div>
);

const NotificationListSkeleton = ({ count = 5 }) => (
  <div
    className="notification-list-skeleton"
    aria-busy="true"
    aria-label="Loading notifications"
  >
    <DarkAwareSkeletonTheme>
      {Array.from({ length: count }).map((_, index) => (
        <NotificationCardSkeletonItem key={`notification-skel-${index}`} />
      ))}
    </DarkAwareSkeletonTheme>
  </div>
);

export default NotificationListSkeleton;
